(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var cleanup = function () {};

  function mountDesktopHeader() {
    cleanup();

    var root = document.querySelector('[data-desktop-fixed-header]');
    if (!root) return;

    var wrapper = root.querySelector('.header-wrapper');
    if (!wrapper) return;

    var desktop = window.matchMedia('(min-width: 769px)');
    var frame = 0;
    var hero = null;
    var resizeObserver = null;
    var overlay = root.dataset.heroOverlay === 'true';
    var barSelector = '#qab_bar, #fsb_bar';
    var bars = [];
    var mutationObserver = null;

    function announcementOffset() {
      var nextBars = Array.from(document.querySelectorAll(barSelector)).filter(function (bar) {
        return !root.contains(bar);
      });
      if (resizeObserver) {
        bars.forEach(function (bar) {
          if (!nextBars.includes(bar)) resizeObserver.unobserve(bar);
        });
        nextBars.forEach(function (bar) {
          if (!bars.includes(bar)) resizeObserver.observe(bar);
        });
      }
      bars = nextBars;
      var rectangles = bars.filter(function (bar) {
        var style = window.getComputedStyle(bar);
        return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0;
      }).map(function (bar) {
        return bar.getBoundingClientRect();
      }).filter(function (rect) {
        return rect.width > 0 && rect.height > 0 && rect.bottom > 0;
      }).sort(function (a, b) { return a.top - b.top; });
      var offset = 0;
      rectangles.forEach(function (rect) {
        if (rect.top <= offset + 1) offset = Math.max(offset, rect.bottom);
      });
      return Math.max(0, Math.round(offset));
    }

    function findHero() {
      var nextHero = overlay ? document.querySelector(
        '#MainContent .hero-wrapper, #MainContent .collection-hero, main .hero-wrapper, main .collection-hero'
      ) : null;
      if (nextHero === hero) return;
      if (resizeObserver && hero) resizeObserver.unobserve(hero);
      hero = nextHero;
      if (resizeObserver && hero) resizeObserver.observe(hero);
    }

    function update() {
      frame = 0;
      if (!desktop.matches) {
        root.classList.remove('desktop-header-ready');
        root.style.removeProperty('--desktop-header-height');
        root.style.removeProperty('--desktop-header-top');
        wrapper.classList.remove('desktop-header-past-hero');
        return;
      }

      findHero();
      var offset = announcementOffset();
      var offsetValue = offset + 'px';
      if (root.style.getPropertyValue('--desktop-header-top') !== offsetValue) {
        root.style.setProperty('--desktop-header-top', offsetValue);
      }
      var height = wrapper.getBoundingClientRect().height;
      var heightValue = height + 'px';
      if (root.style.getPropertyValue('--desktop-header-height') !== heightValue) {
        root.style.setProperty('--desktop-header-height', heightValue);
      }
      wrapper.classList.toggle('desktop-header-past-hero',
        !hero || hero.getBoundingClientRect().bottom <= offset + height
      );
      root.classList.add('desktop-header-ready');
    }

    function scheduleUpdate() {
      if (!frame) frame = window.requestAnimationFrame(update);
    }

    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(scheduleUpdate);
      resizeObserver.observe(wrapper);
    }

    if (window.MutationObserver) {
      mutationObserver = new MutationObserver(function (records) {
        var changed = records.some(function (record) {
          if (root.contains(record.target)) return false;
          if (bars.some(function (bar) {
            return bar.contains(record.target) || record.target.contains(bar);
          })) return true;
          if (record.type !== 'childList') return false;
          return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (node) {
            return node.nodeType === 1 && (node.matches(barSelector) || node.querySelector(barSelector));
          });
        });
        if (changed) scheduleUpdate();
      });
      mutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden']
      });
    }

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    window.addEventListener('load', scheduleUpdate);
    window.addEventListener('pageshow', scheduleUpdate);
    desktop.addEventListener('change', scheduleUpdate);
    document.addEventListener('shopify:section:reorder', scheduleUpdate);
    update();

    cleanup = function () {
      window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', scheduleUpdate);
      window.removeEventListener('resize', scheduleUpdate);
      window.removeEventListener('load', scheduleUpdate);
      window.removeEventListener('pageshow', scheduleUpdate);
      desktop.removeEventListener('change', scheduleUpdate);
      document.removeEventListener('shopify:section:reorder', scheduleUpdate);
      if (resizeObserver) resizeObserver.disconnect();
      if (mutationObserver) mutationObserver.disconnect();
      root.classList.remove('desktop-header-ready');
      root.style.removeProperty('--desktop-header-height');
      root.style.removeProperty('--desktop-header-top');
      wrapper.classList.remove('desktop-header-past-hero');
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountDesktopHeader, { once: true });
  } else {
    mountDesktopHeader();
  }

  document.addEventListener('shopify:section:load', mountDesktopHeader);
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.querySelector('[data-desktop-fixed-header]')) cleanup();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
